import React, { useEffect, useState, useRef } from 'react';
import notificationImage from "../../assets/images/notification.png";
import { Box, Typography, IconButton, Avatar, List, ListItem, ListItemText } from '@mui/material';
import Logo from '../../assets/images/HealthView_Plum.jpg';
import Logout from '../../assets/icons/Logout.svg';
import Info from '../../assets/icons/Info_Filled.svg';
import '../../style/HeaderStyle.css';
import NotificationsIcon from '@mui/icons-material/CircleNotifications';
//import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { ReactComponent as QuestionMarkIcon } from '../../assets/icons/Help_Filled.svg';
import NotificationPanel from './notificationPanel'; 
import { validateConcurrentSessionIfEnabled } from '../../utils/validateConcurrentSessionUtil';  

const styles = ({
    popupOverlay: {
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: '9999'
    },

    popupContainer: {
        background: 'white',
        padding: '24px',
        borderRadius: '12px',
        width: '788px',
        height: '500px',
        top: '161px',
        left: '566px',
        boxShadow: '0 6px 20px rgba(0, 0, 0, 0.3)',
        position: 'centred',
        overflowY: 'auto',
        overflowX: 'hidden'
    },

    popupHeader: {
        display: 'flex',
        fontWeight: 'bold',
        color: '172B4D',
        fontSize: '24px',
        width: 'Fill (740px)',
        gap: '421px',
        alignItems: 'center',
        height: '30px',
        justifyContent: 'space-between'
    },

    popupIcon: {
        width: '24px',
        marginRight: '12px'
    },

    popupCloseButton: {
        background: 'none',
        border: 'none',
        fontSize: '24px',
        cursor: 'pointer',
        color: '#333',
        right: '150px'
    },

    popupBody: {
        marginTop: '16px',
        fontSize: '14px',
        color: '#333',
        overflowY: 'auto',
        overflowX: 'hidden',
    },

    popupDivider: {
        gap: '16px',
        marginTop: '10px',
        border: '2px solid #758195',
        color: ' #758195',
        margin: '9px 0'
    },

});

const Header = (props) => {
    const { pageTitle, isAuthenticated, openNotificationPanel, handleLogout, handleLogin, showNotificationLink ,notificationForPanel, openSupportURL } = props
    const [showAboutPopup, setShowAboutPopup] = useState(false); // State for popup visibility
    const [showNotificationPanel, setShowNotificationPanel] = useState(false);

    return (
        <Box className="header">
            <Box className="header__left">
                <Box className="header__logo" sx={{ display: 'flex', alignItems: 'center' }}>
                    <img src={Logo} alt="Logo" style={{ height: '30px', width: 'auto', marginRight: '4px' }} />
                    <Typography style={{ marginRight: '15px', marginTop: '6px', fontSize: '18px', color: '#3d0808', fontWeight: 'bold' }}>
                        {'Analytics'}
                    </Typography>
                </Box>
                
            </Box>
          
            <Box className="header__actions">
                {showNotificationLink && (
                    <button className="icon-button" title="Notifications" 
                        onClick={async () => {  
                        if (await validateConcurrentSessionIfEnabled()) {  
                            setShowNotificationPanel(prev => !prev);  
                        }  
                    }}>
                        
                            <NotificationsIcon style={{ width: 30, height: 30, marginRight: 1, color: showNotificationPanel ? '#d32f2f' : '#333', }} />
                            {/* <span style={{ fontSize: '14px', color: '#3d0808', fontWeight: 'bold' }}>Notifications</span> */}
                       
                    </button>
                )}
                <button className="icon-button" title="Support Documentation" 
                    onClick={async () => {  
                        if (await validateConcurrentSessionIfEnabled()) {  
                            openSupportURL();  
                        }  
                    }}>
                    <QuestionMarkIcon style={{ width: 30, height: 30, marginRight: 1, color: '#333' }} />
                </button>
            <Box sx={{ display: 'flex', alignItems: 'center', marginBottom: 0.6 }}>
                <Avatar
                    sx={{ bgcolor: '#3d0808', color: '#fff', width: 25, height: 25, fontSize: 16, marginLeft: 0.5, marginRight: 0.5, cursor: 'pointer' }}
                    title={pageTitle ? pageTitle.split('-').pop().trim() : '' }
                >
                    {(() => {
                        const lastPart = pageTitle ? pageTitle.split('-').pop().trim() : '';
                        return lastPart ? lastPart[0].toUpperCase() : '?';
                    })()}
                </Avatar>
            </Box>
                <button className="icon-button" title="Logout" onClick={handleLogout}>
                    <img src={Logout} alt='Logout'></img>
                </button>
            </Box>

            {showNotificationPanel && (
                <NotificationPanel notificationForPanel={notificationForPanel}  onClose={() => setShowNotificationPanel(false)} />
            )}
            
            {/* {showAboutPopup && (
                <div style={styles.popupOverlay}>
                    <div style={styles.popupContainer}>
                        <div style={styles.popupHeader}>
                            <Box className="header__logo">
                                <img src={Logo} alt="Logo" style={{ height: '30px', width: 'auto', marginRight: '8px' }} />
                                <Typography style={{ textAlign: 'left', marginLeft: '30px', fontSize: '12px', color: '#3d0808', fontWeight: 'bold' }}>{'Analytics'}</Typography>
                            </Box>
                            <button style={styles.popupCloseButton} >×</button>
                        </div>
                        <hr style={styles.popupDivider} />
                        <div style={styles.popupBody}>
                           <h1>About Page</h1>
                        </div>
                    </div>
                </div>
            )} */}
        </Box>
    );
};

export default Header;
